var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('OnboardingTopBar',{attrs:{"homepageUrl":"/"}}),_c('LoadingScreen'),_c('div',{staticClass:"title"},[_vm._v("Completing integration...")]),_c('div',{staticClass:"subtitle"},[_vm._v("We are completing the integration with Figma. This may take a few seconds.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }